import { createColumnHelper } from '@tanstack/react-table';
import { SortableHeadCell } from 'components/tables/cells';
import { TextColumnProps } from 'components/tables/columnTypes';
import { Subscription } from 'domain/subscription/interfaces/Subscription';
import AddonsCell from 'components/subscription/AddonsCell';
import PlanCell from 'components/subscription/PlanCell';

const columnHelper = createColumnHelper<Subscription>();

export const bundledSubscriptionTableColumns = {
	plan: (
		applicationId?: string,
		overrideProps?: TextColumnProps<Subscription>,
	) =>
		columnHelper.accessor((row) => 'plan', {
			id: 'plan',
			enableSorting: true,
			header: ({ header }) => (
				<SortableHeadCell
					text="Plan"
					header={header}
					{...overrideProps?.headCellProps}
				/>
			),
			cell: (info) => (
				<PlanCell
					permissionSets={info.row.original.applicationPermissions}
					applicationId={applicationId}
					{...overrideProps?.cellProps}
				/>
			),
			...overrideProps?.columnDefProps,
		}),
	addons: (
		applicationId?: string,
		overrideProps?: TextColumnProps<Subscription>,
	) =>
		columnHelper.accessor((row) => 'addons', {
			id: 'addons',
			enableSorting: true,
			header: ({ header }) => (
				<SortableHeadCell
					text="Addons"
					header={header}
					{...overrideProps?.headCellProps}
				/>
			),
			cell: (info) => (
				<AddonsCell
					permissionSets={info.row.original.applicationPermissions}
					applicationId={applicationId}
					{...overrideProps?.cellProps}
				/>
			),
			...overrideProps?.columnDefProps,
		}),
};
